import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { } from "assets/jss/material-dashboard-react.js";
import { connect } from "react-redux";
import Actions from "redux/actions";
import { withRouter } from "react-router";
import MaterialTable from "components/MaterialTable.js";
import Button from "components/CustomButtons/Button.js";
import PubSub from "pubsub-js";
import { dossierListColumns } from "utils/columns";
import moment from "moment";
import { Switch } from "@material-ui/core";
import api from "axios.js";
import axios from "axios";

class FormList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      closed: false,
      tableLoading: false,
      pageSize: 20,
      page: 0,
    };
    this.tableRef = React.createRef();
    this.cancelSources = new Set();
    this.currentFetchSource = null;
    this.actionsCache = null;
    this.actionsCacheKey = null;
    this._isMounted = false;
  }

  componentDidMount() {
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
    this.cancelAllRequests("DossiersList unmounted");
    this.actionsCache = null;
    this.actionsCacheKey = null;
  }

  updateState = (updater, cb) => {
    if (this._isMounted) {
      this.setState(updater, cb);
    }
  };

  createCancelSource = () => {
    const source = axios.CancelToken.source();
    this.cancelSources.add(source);
    return source;
  };

  releaseCancelSource = (source) => {
    if (source && this.cancelSources.has(source)) {
      this.cancelSources.delete(source);
    }
    if (this.currentFetchSource === source) {
      this.currentFetchSource = null;
    }
  };

  cancelAllRequests = (reason = "cancel") => {
    this.cancelSources.forEach((source) => {
      try {
        source.cancel(reason);
      } catch (_) {}
    });
    this.cancelSources.clear();
    this.currentFetchSource = null;
  };

  cancelCurrentFetch = (reason = "cancel") => {
    if (this.currentFetchSource) {
      try {
        this.currentFetchSource.cancel(reason);
      } catch (_) {}
      this.releaseCancelSource(this.currentFetchSource);
    }
  };

  refreshTableData = () => {
    if (this.tableRef?.current?.onQueryChange) {
      this.tableRef.current.onQueryChange();
    } else {
      this.forceUpdate();
    }
  };

  enrichDossier = (dossier) => {
    if (!dossier) return null;

    const locataire =
      dossier.locataire ||
      dossier.Locataire ||
      (Array.isArray(dossier.locataires) ? dossier.locataires[0] : null) || {
        nom: "",
        prenom: "",
      };

    const appartementRaw = dossier.appartement || dossier.Appartement || {};
    const proprietaires =
      appartementRaw.proprietaires ||
      appartementRaw.Proprietaires ||
      appartementRaw.proprietaire ||
      [];
    const proprietaire =
      (Array.isArray(proprietaires) ? proprietaires[0] : proprietaires) || {
        nom: "",
        prenom: "",
      };

    const appartement = { ...appartementRaw, proprietaire };

    const endDate = dossier.dateFinBail || dossier.DateFinBail;
    const isClosed =
      typeof dossier.isClosed === "boolean"
        ? dossier.isClosed
        : endDate
        ? moment(endDate).isSameOrBefore(moment(), "day")
        : false;

    return { ...dossier, locataire, appartement, isClosed };
  };

  fetchDossiersForTable = (query = {}) => {
    const requestedPage = query.page || 0;
    const requestedPageSize = query.pageSize || this.state.pageSize || 20;
    const search = query.search?.trim();
    const orderBy = query.orderBy?.field;
    const orderDirection = query.orderDirection;
    const filters =
      Array.isArray(query.filters) && query.filters.length
        ? query.filters
            .filter((f) => f?.value)
            .map((f) => ({ field: f?.column?.field, value: f.value }))
        : undefined;

    this.cancelCurrentFetch("new dossier query");
    const source = this.createCancelSource();
    this.currentFetchSource = source;
    this.updateState({
      tableLoading: true,
      page: requestedPage,
      pageSize: requestedPageSize,
    });

    const params = {
      includeClosed: true,
      page: requestedPage + 1,
      pageSize: requestedPageSize,
      search: search || undefined,
      closed: this.state.closed,
      orderBy: orderBy || undefined,
      orderDirection: orderDirection || undefined,
      filters: filters ? JSON.stringify(filters) : undefined,
    };

    const request = api.get("/Dossier/listLite", { params, cancelToken: source.token });

    return request
      .then(({ data }) => {
        const payload = Array.isArray(data?.data)
          ? data.data
          : Array.isArray(data?.rows)
          ? data.rows
          : Array.isArray(data)
          ? data
          : [];

        const dossiers = payload.map(this.enrichDossier).filter(Boolean);

        const totalCount =
          typeof data?.totalCount === "number"
            ? data.totalCount
            : typeof data?.total === "number"
            ? data.total
            : dossiers.length;

        this.updateState({ tableLoading: false });

        return { data: dossiers, page: requestedPage, totalCount };
      })
      .catch((error) => {
        if (axios.isCancel(error)) {
          return { data: [], page: requestedPage, totalCount: 0 };
        }
        console.error("Unable to load dossiers", error);
        PubSub.notif({
          txt: "Impossible de charger les dossiers.",
          color: "danger",
        });
        this.updateState({ tableLoading: false });
        return { data: [], page: requestedPage, totalCount: 0 };
      })
      .finally(() => this.releaseCancelSource(source));
  };

  getActions = () => {
    if (this.actionsCache && this.actionsCacheKey === this.props.canDelete) {
      return this.actionsCache;
    }
    const { canDelete } = this.props;
    const actions = [
      {
        icon: "edit",
        tooltip: "Modifier le dossier",
        onClick: (event, rowData) =>
          this.props.history.push(`/dossiers/${rowData.id}/edit`),
      },
      {
        icon: "remove_red_eye",
        tooltip: "Voir les details du dossier",
        onClick: (event, rowData) =>
          this.props.history.push(`/dossiers/${rowData.id}`),
      },
      {
        icon: "home",
        tooltip: "Voir les details de l'appartement",
        onClick: (event, rowData) =>
          this.props.history.push(`/appartements/${rowData.appartement.id}`),
      },
      {
        icon: "supervised_user_circle",
        tooltip: "Voir les details du locataire",
        onClick: (event, rowData) =>
          this.props.history.push(`/locataires/${rowData.locataire.id}`),
      },
      canDelete &&
        ((rowData) => {
          const isClosed =
            typeof rowData?.isClosed === "boolean"
              ? rowData.isClosed
              : rowData?.dateFinBail
              ? moment(rowData.dateFinBail).isSameOrBefore(moment(), "day")
              : false;
          return {
            icon: isClosed ? "delete" : "close",
            tooltip: isClosed ? "Supprimer le dossier" : "Clore le dossier",
            onClick: (event, rd) =>
              PubSub.confirm({
                title: isClosed ? "Supprimer le dossier" : "Clore le dossier",
                subtitle: "Cette action est irreversible.",
                onAgree: (_) => {
                  if (isClosed) {
                    this.props
                      .dispatch(Actions.deleteDossier(rd.id))
                      .then(() => this.refreshTableData());
                  } else {
                    const appartementId = rd?.appartement?.id;
                    const locataireId = rd?.locataire?.id;
                    if (appartementId && locataireId) {
                      this.props
                        .dispatch(Actions.removeTenant(appartementId, locataireId))
                        .then(() => this.refreshTableData());
                    }
                  }
                },
              }),
          };
        }),
      {
        icon: (p) => <Button color="primary">Nouveau Dossier</Button>,
        isFreeAction: true,
        onClick: (event) => this.props.history.push(`/dossiers/new`),
      },
    ].filter(Boolean);
    this.actionsCache = actions;
    this.actionsCacheKey = canDelete;
    return this.actionsCache;
  };

  render() {
    const c = this.props.classes;
    const { closed } = this.state;
    return (
      <div className={c.container}>
        <div className="fullW row align-c justify-e">
          <p
            style={{
              color: closed ? "green" : "unset",
              fontWeight: closed ? "bold" : "unset",
            }}
          />
          Clos
          <Switch
            checked={!closed}
            onChange={(_, checked) => {
              const showClosed = !checked;
              this.setState({ closed: showClosed }, this.refreshTableData);
            }}
          />
          <p
            style={{
              color: !closed ? "green" : "unset",
              fontWeight: !closed ? "bold" : "unset",
            }}
          >
            En cours
          </p>
        </div>
        <MaterialTable
          title=""
          isLoading={this.state.tableLoading}
          columns={dossierListColumns}
          actions={this.getActions()}
          data={this.fetchDossiersForTable}
          onRowClick={(event, rowData) =>
            rowData?.locataire?.id
              ? this.props.history.push(`/locataires/${rowData.locataire.id}`)
              : null
          }
          options={{
            filtering: true,
            pageSize: this.state.pageSize,
            actionsColumnIndex: -1,
          }}
          tableRef={this.tableRef}
        />
      </div>
    );
  }
}

const styles = (theme) => ({
  container: {},
});

const mapStateToProps = (state) => ({
  canDelete: state.reducer.canDelete,
});

export default withRouter(
  withStyles(styles)(connect(mapStateToProps)(FormList))
);
